<template>
	<div class="card mb-4">
		<div class="wizard wizard-inline card-body py-2">
		<a v-for="(step,i) in steps" v-bind:key="i" :href="step.active?'#':('/#'+step.link)" :class="`step ${step.active?'active':''}`">
			<span :class="`step-number`" :id="`step${i+1}`">
				{{i+1}}
			</span>
			<span class="step-text mr-2">{{step.label}}</span>
			<i class="material-symbols-outlined step-chevron" v-if="i<steps.length-1">chevron_right</i>
		</a>
		</div>
	</div>
</template>
<script>
export default {
  name: 'Steps',
  props: {
    steps:Array
  }
}
</script>